import styles from "./YaPagination.module.css";
import Pagination from "react-bootstrap/Pagination";
import React, {useEffect, useState} from "react";
import {YaPaginationInterface} from "./YaPaginationInterface";

export const YaPagination = (props: YaPaginationInterface) => {

    const [numberOfPages, setNumberOfPages] = useState<number>(0);
    const [pageEllipseNumber, setPageEllipseNumber] = useState<number | undefined>(undefined);
    const [pages, setPages] = useState<any[]>([]);

    useEffect(() => {
        setNumberOfPages(Math.ceil(props.itemsTotal / props.pageSize));
    }, [props.itemsTotal, props.pageSize]);
    
    useEffect(() => {
        if (props.activePage === 1) {
            setPageEllipseNumber(undefined);
        }
    }, [props.activePage])

    useEffect(() => {
            let paginationItem = [];

            const start = pageEllipseNumber === undefined ? 1 : pageEllipseNumber;

            for (let number = start; number <= numberOfPages; number++) {
                if (number < start + props.showNumberOfPagesMax) {
                    paginationItem.push(<Pagination.Item
                        key={number}
                        active={number == props.activePage}
                        onClick={() => {
                            props.changePage(number);
                        }}
                    >
                        {number}
                    </Pagination.Item>);
                }
            }

            if (start > 1) {
                const newPaginationItem = [<Pagination.Ellipsis
                    key={start - props.showNumberOfPagesMax}
                    onClick={() => {
                        if (start - props.showNumberOfPagesMax < 1) {
                            setPageEllipseNumber(undefined);
                            props.changePage(1);
                            return;
                        }
                        setPageEllipseNumber(start - props.showNumberOfPagesMax);
                        props.changePage(start - props.showNumberOfPagesMax);
                    }}
                />
                ];

                paginationItem = [...newPaginationItem, ...paginationItem];
            }

            if (start + props.showNumberOfPagesMax < numberOfPages) {
                paginationItem.push(<Pagination.Ellipsis
                    key={start + props.showNumberOfPagesMax}
                    onClick={() => {
                        setPageEllipseNumber(start + props.showNumberOfPagesMax);
                        props.changePage(start + props.showNumberOfPagesMax);
                    }}
                />);
            }
            setPages(paginationItem);
        },
        [numberOfPages, props.activePage, pageEllipseNumber]
    );

    return (
        <>
            <Pagination className={styles.pagingBottom} size={undefined}>
                <Pagination.First
                    disabled={props.activePage === 1}
                    onClick={() => {
                        if (numberOfPages > props.showNumberOfPagesMax + 1) {
                            setPageEllipseNumber(undefined);
                        }
                        props.changePage(1);
                    }}
                >

                </Pagination.First>
                {pages}
                <Pagination.Last
                    disabled={props.activePage === numberOfPages}
                    onClick={() => {
                        if (numberOfPages > props.showNumberOfPagesMax + 1) {
                            setPageEllipseNumber(numberOfPages - (props.showNumberOfPagesMax - 1));
                        }
                        props.changePage(numberOfPages);
                    }}
                />
            </Pagination>
        </>
    )
}
